(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MedFrequencyToDialogController', MedFrequencyToDialogController);

    MedFrequencyToDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'MedFrequencyTo', 'Medication', 'Corporation'];

    function MedFrequencyToDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, MedFrequencyTo, Medication, Corporation) {
        var vm = this;

        vm.medFrequencyTo = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.medFrequencyTo.id !== null) {
                MedFrequencyTo.update(vm.medFrequencyTo, onSaveSuccess, onSaveError);
            } else {
                MedFrequencyTo.save(vm.medFrequencyTo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:medFrequencyToUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
